import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TextMessageBuilderForm } from '../interfaces';
import { MatInputModule } from '@angular/material/input';
import { DynamicComponentSelectorModule } from '@galaxy/templates';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'sms-builder-form',
  templateUrl: 'text-message-builder-form.component.html',
  styleUrls: ['./text-message-builder-form.component.scss'],
  imports: [CommonModule, GalaxyFormFieldModule, ReactiveFormsModule, MatInputModule, DynamicComponentSelectorModule],
})
export class TextMessageBuilderFormComponent implements OnInit {
  smsForm = new FormGroup({
    name: new FormControl(''),
    message: new FormControl(''),
  });

  @ViewChild('smsText') smsText?: ElementRef<HTMLTextAreaElement>;

  @Input()
  set setInitialInputText(inputText: TextMessageBuilderForm) {
    this.smsForm.patchValue(inputText);
  }

  @Input() allowDynamic: boolean;

  @Output() template: EventEmitter<TextMessageBuilderForm> = new EventEmitter();
  @Output() valid: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    this.smsForm.valueChanges.subscribe((value) => {
      this.template.emit(value as TextMessageBuilderForm);
    });
    this.smsForm.statusChanges.subscribe((status) => {
      this.valid.emit(status === 'VALID');
    });
  }

  emitNewTemplateValue(value: string) {
    this.template.emit({ message: value } as TextMessageBuilderForm);
  }
}
